module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prices-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-extrasizes",
      "to": {
        name: 'Extrasizes'
      },
      "md-label": "Список"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-wayextrasizes",
      "to": {
        name: 'WayExtrasizes'
      },
      "md-label": "Список по направлениям"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d464f1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/extrasize/FreightExtrasizesMenu.vue
// module id = 1226
// module chunks = 0